import { stroot } from '@birdi/js-sdk';
import React from 'react';
import AsyncSelect from 'react-select/async';
import { css } from '@emotion/react';
import { forms } from '@birdi/theme';
import { organisation as organisationAPI } from '@birdi/js-sdk/src/public';
import { CSSObjectWithLabel, MenuPlacement, OptionProps } from 'react-select';

interface Option {
  value: string;
  label: string;
}

export function loadOptions() {
  return organisationAPI.getWorkspaces(stroot('xon5oo')).then(
    (response) =>
      response.body?.items.map((item) => ({
        value: item.id,
        label: item.name,
      })) ?? [],
  );
}

interface WorkspaceSelectProps {
  onChange: (value: Option) => void;
  defaultValue?: Option;
  placement?: MenuPlacement;
  placeholder?: string;
  disabledOptions?: string[];
  containerStyles?: CSSObjectWithLabel;
  controlStyles?: CSSObjectWithLabel;
  isClearable?: boolean;
}

export default ({
  onChange,
  defaultValue,
  placement = 'bottom',
  placeholder = 'Select workspace',
  disabledOptions = [],
  containerStyles = {},
  controlStyles = {},
  isClearable = false,
}: WorkspaceSelectProps) => {
  const Option = (props: OptionProps<Option>) => (
    <button
      type="button"
      onClick={() => props.selectOption(props.data)}
      disabled={disabledOptions.includes(props.data.value)}
      css={(theme) => css`
        text-align: left;
        padding: 0.5em;
        margin: 0;
        width: 100%;
        &:disabled {
          background: ${theme.mono20};
        }
      `}
    >
      {props.data.label}
    </button>
  );

  return (
    <AsyncSelect
      menuPlacement={placement}
      defaultOptions
      cacheOptions
      components={{ Option }}
      defaultValue={defaultValue}
      onChange={(option) => onChange(option as Option)}
      loadOptions={() => loadOptions()}
      placeholder={placeholder}
      isClearable={isClearable}
      styles={{
        ...forms.reactSelect,
        container: (base) => ({
          ...base,
          ...containerStyles,
        }),
        input: (base) => ({
          ...base,
          padding: '0.65rem',
        }),
        control: (base) => ({
          ...base,
          height: '100%',
          borderRadius: '3px',
          border: `solid #B9B9B9 1px`,
          ...controlStyles,
        }),
        menu: (base) => ({
          ...base,
          maxHeight: '120px',
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: '120px',
        }),
      }}
    />
  );
};
